import { CleaningHistoryEntry } from '../types';

/**
 * Parses the newline-delimited `cleanHistory` string into structured rows.
 *
 * Each non-empty line is expected in the form `"<date> - <status>"`, e.g.
 * `"21 Jul 2026 - Missed"`. Lines without a ` - ` separator are treated as a
 * date-only entry with an empty status. Trailing / blank lines are ignored.
 */
export const parseCleaningHistory = (history?: string): CleaningHistoryEntry[] => {
  if (!history) return [];

  return history
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line.length > 0)
    .map((line) => {
      const separatorIndex = line.indexOf(' - ');
      if (separatorIndex === -1) {
        return { date: line, status: '' };
      }
      return {
        date: line.slice(0, separatorIndex).trim(),
        status: line.slice(separatorIndex + 3).trim(),
      };
    });
};
